import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Breadcrumbs,
  Link,
  Paper,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Business as OperationsIcon,
  MoveToInbox as ReclassifyIcon,
} from '@mui/icons-material';
import { useNavigationCore } from '../../../core/router/navigation';
import { useReclassifyCore } from '../../../core/modules/reclassify';
import {
  ReclassifyList,
  ReclassifyFilters,
  ReclassifyDialog,
} from '../../components/operations/reclassify';
import { ArticleForReclassify } from '../../../core/modules/reclassify/interfaces/get-articles-for-reclassify';

export const ReclassifyScreen: React.FC = () => {
  const { goToWelcome } = useNavigationCore();
  const { clearReclassify } = useReclassifyCore();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedArticles, setSelectedArticles] = useState<
    ArticleForReclassify[]
  >([]);

  // Limpiar estado al desmontar el componente
  useEffect(() => {
    return () => {
      clearReclassify();
    };
  }, [clearReclassify]);

  const handleOpenDialog = (articles: ArticleForReclassify[]) => {
    setSelectedArticles(articles);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedArticles([]);
  };

  const handleSuccess = () => {
    // El diálogo ya refrescará los datos automáticamente
    setSelectedArticles([]);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>

      {/* Header */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <ReclassifyIcon color="primary" sx={{ fontSize: 32 }} />
          <Typography variant="h4" component="h1">
            Reclasificar Artículos
          </Typography>
        </Box>
        <Typography variant="body1" color="text.secondary">
          Gestiona la reclasificación de artículos entre contenedores y
          ubicaciones. Selecciona los artículos que deseas reclasificar y
          asígnalos a su nueva ubicación.
        </Typography>
      </Paper>

      {/* Contenido principal */}
      <Box display="flex" flexDirection="column" gap={3}>
        {/* Filtros */}
        <ReclassifyFilters />

        {/* Lista de artículos */}
        <ReclassifyList onOpenReclassifyDialog={handleOpenDialog} />
      </Box>

      {/* Diálogo de reclasificación */}
      <ReclassifyDialog
        open={dialogOpen}
        articles={selectedArticles}
        onClose={handleCloseDialog}
        onSuccess={handleSuccess}
      />
    </Container>
  );
};
